export * from './reset-password.view';
